import * as _ from 'lodash-es';
import Quill, { Delta } from 'quill/core';
import CodeEmbed from '../formats/CodeEmbed';

const insertCodeEmbed = ({
  quill,
  index,
  language,
  embedDelta,
}: {
  quill: Quill;
  index: number;
  language: string;
  embedDelta: Delta;
}) => {
  const delta = new Delta()
    .retain(index)
    .insert({ 'code-embed': embedDelta.ops }, { language });
  quill.updateContents(delta, Quill.sources.USER);

  const [codeEmbed] = quill.getLine(index);
  if (codeEmbed instanceof CodeEmbed) {
    codeEmbed.allowPreviewingAtFirstRender = false;

    _.defer(() => {
      // exclude the trailing \n
      codeEmbed.setSelection(0, embedDelta.length() - 1, Quill.sources.USER);
    });
  }
};

export default insertCodeEmbed;
